export * from './SupportedLanguages.enum';

const en = require('./en.json');
const bg = require('./bg.json');

export const Translations: Record<string, any> = { en, bg };
